<template>
  <v-container>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <TextArea
          :textTitle="endPointName"
          :textLinesArray="endpointDesc"
        ></TextArea>
        <TextArea
          :textTitle="filteringTitle"
          :textLinesArray="filteringText"
        ></TextArea>
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <EndpointCard cardTitle="ENDPOINTS" :endpoints="endpoints" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <Attribute :attributes="calendarEventDTO" :endpoint="responseTitle" />
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <ResponseCard :response="response" :cardTitle="responseCodeTitle" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0"> </v-row>
  </v-container>
</template>
<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";

const endPointName = "Budgets";
const ekURL = "/Accountancy/Budget";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
  },
  computed: {
    calendarEventDTO() {
      return this.$t("calendarevents.postAttributes");
    },
  },
  data() {
    return {
      filteringTitle: "Filtrering",
      filteringText: ["På dette endpoint kan man påføre filtrering med parametrene, <code>fromDate</code>, <code>toDate</code>, <code>page</code>, <code>pageSize</code>, <code>searchAttribute</code>, <code>search</code> og <code>updatedAfter</code>."],
      responseTitle: `The ${endPointName} Object`,
      responseCodeTitle: `${endPointName.toUpperCase()} RESPONSE. E-KOMPLET URL: ${ekURL}`,
      endPointName: endPointName,
      endpointDesc: [
      ],
      endpoints: [
        {
          verb: "GET",
          path: `/api/v4.0/${endPointName.toLowerCase()}`,
        },
        {
          verb: "GET",
          path: `/api/v4.0/${endPointName.toLowerCase()}/:id`,
        },
        {
          verb: "POST",
          path: `/api/v4.0/${endPointName.toLowerCase()}`,
        },
      ],
      response: [
        {
          "id": 194,
          "financialAccountNumber": 1290,
          "financialAccountName": "Tilbudsarbejde - a/c",
          "description": "Test",
          "startDate": "2025-04-01T00:00:00",
          "endDate": "2025-04-04T00:00:00",
          "amount": 0.00,
          "dimensionCarrierName": null,
          "dimensionDepartmentName": null,
          "dimensionPurposeName": null,
          "dimensionCarrierID": null,
          "dimensionDepartmentID": null,
          "dimensionPurposeID": null,
          "finAccountID": 4
        }
    ],
    attributes: [
      {
        name: "id",
        type: "int",
        desc: "Internal property.",
        default: "true",
      },
    ],
    };
  },
  };
</script>
<style scoped>
.text-area {
  padding-right: 10%;
}
.left-column {
  margin-left: 12%;
}
.right-column {
  margin-right: 12%;
}
</style>
